const types = {
  OPEN: "OPEN",
  CLOSE: "CLOSE",
};

const INITIAL_STATE = {
  isOpen: false,
  message: "",
  color: "success",
};

export const globalSnackbarReducer = (
  state = INITIAL_STATE,
  { type, payload }
) => {
  switch (type) {
    case types.OPEN:
      return {
        ...state,
        isOpen: true,
        message: payload.message,
        color: payload.color,
      };
    case types.CLOSE:
      return {
        ...state,
        isOpen: false,
        message: "",
        color: "success"
      };

    default:
      return state;
  }
};

export function openSnackbar(message, color) {
  return {
    type: types.OPEN,
    payload: {
      message,
      color,
    },
  };
}
export function closeSnackbar() {
  return { type: types.CLOSE };
}
